import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useRouter } from 'next/router';
import { CopyToClipboard } from 'react-copy-to-clipboard';

import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import OnSellsTab from './TabOnSells';
import SettingsTab from './TabSettings';

import { toast } from 'react-toastify';
import FollowersDialog from '../Dialog/FollowersDialog';
import FollowButton from '../FollowButton/index';
import ImageViewerDialog from '../Dialog/DialogImageViewer';
import { Alert, AlertTitle } from '@material-ui/lab';
import {
  collection,
  getDoc,
  getDocs,
  query,
  where,
  doc,
} from 'firebase/firestore/lite';
import { firebaseFireStore } from '../../config/firebaseFirestore';

let intailCheck = true;
let isMyProfile = '';

export default function ArtistContainer(props) {
  const classes = useStyles();
  const userDataRedux = useSelector((state) => state.authReducer.userData);
  const userDataLoadingRedux = useSelector(
    (state) => state.authReducer.userLoading,
  );

  const router = useRouter();
  const [artistProfile, setartistProfile] = useState(null);
  const [value, setValue] = useState(0);
  // const [imageHash, setimageHash] = useState(Date.now());
  const [followersDialogState, setfollowersDialogState] = useState(false);
  const [followersCount, setfollowersCount] = useState(0);
  const [imageViewerDialogState, setimageViewerDialogState] = useState(false);
  const [isEditable, setisEditable] = useState(true);
  const [artistUrl, setartistUrl] = useState('');
  const [showmore, setShowmore] = useState(false);

  const [isAdmin, setisAdmin] = useState(false);
  const { artistId, tab, collectorId } = router.query;
  const [newCache, updateCache] = React.useState(Date.now());

  const toastId = React.useRef(null);

  const forceUpdate = () => {
    updateCache(Date.now());
  };
  useEffect(() => {
    if (artistId && !userDataLoadingRedux && props.artistData) {
      getArtistData();
    }
  }, [artistId, userDataLoadingRedux, userDataRedux, props.artistData]);

  useEffect(() => {
    if (tab === 'Settings') {
      setValue(3);
    }
  }, [tab]);

  useEffect(() => {
    if (
      userDataRedux &&
      userDataRedux.uid &&
      artistProfile &&
      artistProfile.creatorId &&
      userDataRedux.uid === artistProfile.creatorId
    ) {
      setisEditable(true);
    } else if (
      userDataRedux &&
      userDataRedux.uid &&
      artistProfile &&
      artistProfile.creatorId &&
      userDataRedux.uid !== artistProfile.creatorId &&
      intailCheck
    ) {
      adminCheck();
    }
  }, [userDataRedux, artistProfile]);

  if (userDataRedux?.uid !== undefined) {
    isMyProfile = userDataRedux?.uid === artistProfile?.creatorId;
  }

  useEffect(() => {
    setartistUrl(`${window.location.origin}/artist/${artistId}`);
  }, []);

  const adminCheck = async () => {
    intailCheck = false;
    // console.lo/g("run ccheck", userDataRedux.uid);

    const q = query(
      collection(firebaseFireStore, 'admin'),
      where('admins', 'array-contains-any', [userDataRedux.uid]),
    );

    let dbRef = await getDocs(q);

    if (!dbRef.empty) {
      setisEditable(true);
      return true;
    } else {
      return false;
    }
  };

  useEffect(() => {
    if (userDataRedux) {
      getDoc(doc(firebaseFireStore, 'admin', 'adminList')).then((doc) => {
        if (
          doc.exists &&
          doc.data() &&
          doc.data()?.admins?.includes(userDataRedux.uid)
        ) {
          //user is admin
          setisAdmin(true);
        }
      });
    }
  }, [userDataRedux]);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const getArtistData = async () => {
    if (props?.artistData) {
      let artObj = props.artistData;
      console.log('artObj', artObj, userDataRedux);

      let showArtistPage = false;
      if (artObj && artObj.adminState === 'APPROVED') {
        showArtistPage = true;
      } else {
        console.log('Reject state');
        if (
          userDataRedux &&
          userDataRedux.uid &&
          artObj &&
          artObj.creatorId &&
          userDataRedux.uid === artObj.creatorId
        ) {
          console.log('owner of creator');

          showArtistPage = true;
          setisEditable(true);
        } else if (userDataRedux && userDataRedux.uid) {
          console.log('admin check');
          let check = await adminCheck();
          if (check) {
            console.log('admin pass');
            showArtistPage = true;
          }
        }
      }

      console.log('showArtistPage', showArtistPage);
      if (showArtistPage) {
        setartistProfile({
          ...artObj,
        });
        setfollowersCount(artObj && artObj.followers ? artObj.followers : 0);
      } else {
        router.push('/');
      }
    } else {
      router.push('/');
    }
  };

  return (
    <>
      <main className="main">
        <section className="relative block h-300-px">
          <div
            className="absolute top-0 w-full h-full bg-center bg-cover"
            style={{
              backgroundImage:
                artistProfile && artistProfile.thumbnailImage
                  ? `url(${
                      artistProfile.thumbnailImage +
                      '_1920x1920?alt=media&t=' +
                      newCache
                    })`
                  : 'linear-gradient(90deg, rgba(252,213,10,1) 0%, rgba(241,102,4,1) 100%)',
              background:
                'linear-gradient(90deg, rgba(252,213,10,1) 0%, rgba(241,102,4,1) 100%)',
              backgroundRepeat: 'no-repeat',
              backgroundSize: 'cover',
              backgroundPosition: 'center',
            }}
          ></div>
        </section>
        <div className="center_container">
          <div className="container">
            <div className="row row--grid">
              <div className="w-full discover-screen-artist1 xl:w-3/12 lg:w-4/12 md:w-6/12">
                <div className="author author--page">
                  <div className="author__meta">
                    <div
                      className={'author__avatar'}
                      style={{ backgroundColor: '#ff9700' }}
                      onClick={() => setimageViewerDialogState(true)}
                    >
                      <img
                        alt="profile-image"
                        className="cursor-pointer"
                        src={
                          artistProfile && artistProfile.photoUrl
                            ? artistProfile.photoUrl +
                              '_250x250?alt=media&t=' +
                              newCache
                            : '/img/avatars/avatar.jpg'
                        }
                        onError={(e) => {
                          e.target.onerror = null;
                          e.target.src = '/img/avatars/avatar.jpg';
                        }}
                      />
                    </div>
                    {artistProfile && artistProfile.name && (
                      <h1 className="author__name">
                        {artistProfile.name.length > 20
                          ? artistProfile.name.substring(0, 20) + '...'
                          : artistProfile.name}
                      </h1>
                    )}

                    {artistProfile && artistProfile.bio && (
                      <p
                        style={{
                          wordBreak: 'break-word',
                        }}
                      >
                        {showmore === false
                          ? artistProfile.bio.substring(0, 80) + '...'
                          : artistProfile.bio}
                        {showmore === true ? (
                          <a
                            className={
                              artistProfile.bio.length > 80 ? 'link' : 'hidden'
                            }
                            onClick={() => setShowmore(false)}
                          >
                            Show less
                          </a>
                        ) : (
                          <a
                            className={
                              artistProfile.bio.length > 80 ? 'link' : 'hidden'
                            }
                            onClick={() => setShowmore(true)}
                          >
                            Show more
                          </a>
                        )}
                      </p>
                    )}

                    <div className="author__code">
                      <p
                        style={{
                          width: '95%',
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          padding: '0px 10px',
                        }}
                      >
                        {artistUrl.length > 28
                          ? artistUrl.substring(0, 28) + '...'
                          : artistUrl}
                      </p>
                      <div>
                        <CopyToClipboard
                          text={artistUrl}
                          onCopy={() => {
                            if (!toast.isActive(toastId.current)) {
                              toastId.current = toast.success('URL copied.', {
                                position: 'bottom-left',
                                autoClose: 10000,
                                hideProgressBar: false,
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: true,
                                zIndex: 2147483641,
                              });
                            }
                          }}
                        >
                          <button type="button">
                            <span>Copied</span>
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 24 24"
                            >
                              <path d="M18,19H6a3,3,0,0,1-3-3V8A1,1,0,0,0,1,8v8a5,5,0,0,0,5,5H18a1,1,0,0,0,0-2Zm5-9.06a1.31,1.31,0,0,0-.06-.27l0-.09a1.07,1.07,0,0,0-.19-.28h0l-6-6h0a1.07,1.07,0,0,0-.28-.19l-.09,0L16.06,3H8A3,3,0,0,0,5,6v8a3,3,0,0,0,3,3H20a3,3,0,0,0,3-3V10S23,10,23,9.94ZM17,6.41,19.59,9H18a1,1,0,0,1-1-1ZM21,14a1,1,0,0,1-1,1H8a1,1,0,0,1-1-1V6A1,1,0,0,1,8,5h7V8a3,3,0,0,0,3,3h3Z" />
                            </svg>
                          </button>
                        </CopyToClipboard>
                      </div>
                    </div>

                    <div className="author__social icons-wrapper pr-2">
                      {artistProfile && artistProfile.twitter && (
                        <a
                          href={artistProfile && artistProfile.twitter}
                          target="_self"
                          rel="noreferrer"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24"
                          >
                            <path d="M22,5.8a8.49,8.49,0,0,1-2.36.64,4.13,4.13,0,0,0,1.81-2.27,8.21,8.21,0,0,1-2.61,1,4.1,4.1,0,0,0-7,3.74A11.64,11.64,0,0,1,3.39,4.62a4.16,4.16,0,0,0-.55,2.07A4.09,4.09,0,0,0,4.66,10.1,4.05,4.05,0,0,1,2.8,9.59v.05a4.1,4.1,0,0,0,3.3,4A3.93,3.93,0,0,1,5,13.81a4.9,4.9,0,0,1-.77-.07,4.11,4.11,0,0,0,3.83,2.84A8.22,8.22,0,0,1,3,18.34a7.93,7.93,0,0,1-1-.06,11.57,11.57,0,0,0,6.29,1.85A11.59,11.59,0,0,0,20,8.45c0-.17,0-.35,0-.53A8.43,8.43,0,0,0,22,5.8Z" />
                          </svg>
                        </a>
                      )}
                      {artistProfile && artistProfile.tiktok && (
                        <a
                          href={artistProfile && artistProfile.tiktok}
                          target="_self"
                          rel="noreferrer"
                        >
                          <svg
                            viewBox="-32 0 512 512"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path d="m432.734375 112.464844c-53.742187 0-97.464844-43.722656-97.464844-97.464844 0-8.285156-6.714843-15-15-15h-80.335937c-8.28125 0-15 6.714844-15 15v329.367188c0 31.59375-25.707032 57.296874-57.300782 57.296874s-57.296874-25.703124-57.296874-57.296874c0-31.597657 25.703124-57.300782 57.296874-57.300782 8.285157 0 15-6.714844 15-15v-80.335937c0-8.28125-6.714843-15-15-15-92.433593 0-167.632812 75.203125-167.632812 167.636719 0 92.433593 75.199219 167.632812 167.632812 167.632812 92.433594 0 167.636719-75.199219 167.636719-167.632812v-145.792969c29.851563 15.917969 63.074219 24.226562 97.464844 24.226562 8.285156 0 15-6.714843 15-15v-80.335937c0-8.28125-6.714844-15-15-15zm0 0" />
                          </svg>
                          {/* <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24"
                          >
                            <path d="M21.20905,6.41669H22V4.08331H14.51978l-2.48584,9.16663h-.068L9.50269,4.08331H2V6.41663h.76837A.89578.89578,0,0,1,3.5,7.11139v9.83032a.84093.84093,0,0,1-.73163.6416H2v2.33338H8V17.58331H6.5V7.25h.08752L10.0451,19.91669h2.712L16.25989,7.25h.07355V17.58331H14.83337v2.33338H22V17.58331h-.79095a.83931.83931,0,0,1-.70905-.6416V7.11145A.8976.8976,0,0,1,21.20905,6.41669Z" />
                          </svg> */}
                        </a>
                      )}
                      {artistProfile && artistProfile.facebook && (
                        <a
                          href={artistProfile && artistProfile.facebook}
                          target="_self"
                          rel="noreferrer"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24"
                          >
                            <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"></path>
                          </svg>
                        </a>
                      )}

                      {artistProfile && artistProfile.instagram && (
                        <a
                          href={artistProfile && artistProfile.instagram}
                          target="_self"
                          rel="noreferrer"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24"
                          >
                            <path d="M17.34,5.46h0a1.2,1.2,0,1,0,1.2,1.2A1.2,1.2,0,0,0,17.34,5.46Zm4.6,2.42a7.59,7.59,0,0,0-.46-2.43,4.94,4.94,0,0,0-1.16-1.77,4.7,4.7,0,0,0-1.77-1.15,7.3,7.3,0,0,0-2.43-.47C15.06,2,14.72,2,12,2s-3.06,0-4.12.06a7.3,7.3,0,0,0-2.43.47A4.78,4.78,0,0,0,3.68,3.68,4.7,4.7,0,0,0,2.53,5.45a7.3,7.3,0,0,0-.47,2.43C2,8.94,2,9.28,2,12s0,3.06.06,4.12a7.3,7.3,0,0,0,.47,2.43,4.7,4.7,0,0,0,1.15,1.77,4.78,4.78,0,0,0,1.77,1.15,7.3,7.3,0,0,0,2.43.47C8.94,22,9.28,22,12,22s3.06,0,4.12-.06a7.3,7.3,0,0,0,2.43-.47,4.7,4.7,0,0,0,1.77-1.15,4.85,4.85,0,0,0,1.16-1.77,7.59,7.59,0,0,0,.46-2.43c0-1.06.06-1.4.06-4.12S22,8.94,21.94,7.88ZM20.14,16a5.61,5.61,0,0,1-.34,1.86,3.06,3.06,0,0,1-.75,1.15,3.19,3.19,0,0,1-1.15.75,5.61,5.61,0,0,1-1.86.34c-1,.05-1.37.06-4,.06s-3,0-4-.06A5.73,5.73,0,0,1,6.1,19.8,3.27,3.27,0,0,1,5,19.05a3,3,0,0,1-.74-1.15A5.54,5.54,0,0,1,3.86,16c0-1-.06-1.37-.06-4s0-3,.06-4A5.54,5.54,0,0,1,4.21,6.1,3,3,0,0,1,5,5,3.14,3.14,0,0,1,6.1,4.2,5.73,5.73,0,0,1,8,3.86c1,0,1.37-.06,4-.06s3,0,4,.06a5.61,5.61,0,0,1,1.86.34A3.06,3.06,0,0,1,19.05,5,3.06,3.06,0,0,1,19.8,6.1,5.61,5.61,0,0,1,20.14,8c.05,1,.06,1.37.06,4S20.19,15,20.14,16ZM12,6.87A5.13,5.13,0,1,0,17.14,12,5.12,5.12,0,0,0,12,6.87Zm0,8.46A3.33,3.33,0,1,1,15.33,12,3.33,3.33,0,0,1,12,15.33Z" />
                          </svg>
                        </a>
                      )}
                      {artistProfile && artistProfile.apple && (
                        <a
                          href={artistProfile && artistProfile.apple}
                          target="_blank"
                          rel="noreferrer"
                        >
                          <svg
                            viewBox="0 0 256 315"
                            version="1.1"
                            xmlns="http://www.w3.org/2000/svg"
                            preserveAspectRatio="xMidYMid"
                          >
                            <g>
                              <path d="M213.803394,167.030943 C214.2452,214.609646 255.542482,230.442639 256,230.644727 C255.650812,231.761357 249.401383,253.208293 234.24263,275.361446 C221.138555,294.513969 207.538253,313.596333 186.113759,313.991545 C165.062051,314.379442 158.292752,301.507828 134.22469,301.507828 C110.163898,301.507828 102.642899,313.596301 82.7151126,314.379442 C62.0350407,315.16201 46.2873831,293.668525 33.0744079,274.586162 C6.07529317,235.552544 -14.5576169,164.286328 13.147166,116.18047 C26.9103111,92.2909053 51.5060917,77.1630356 78.2026125,76.7751096 C98.5099145,76.3877456 117.677594,90.4371851 130.091705,90.4371851 C142.497945,90.4371851 165.790755,73.5415029 190.277627,76.0228474 C200.528668,76.4495055 229.303509,80.1636878 247.780625,107.209389 C246.291825,108.132333 213.44635,127.253405 213.803394,167.030988 M174.239142,50.1987033 C185.218331,36.9088319 192.607958,18.4081019 190.591988,0 C174.766312,0.636050225 155.629514,10.5457909 144.278109,23.8283506 C134.10507,35.5906758 125.195775,54.4170275 127.599657,72.4607932 C145.239231,73.8255433 163.259413,63.4970262 174.239142,50.1987249"></path>
                            </g>
                          </svg>
                        </a>
                      )}

                      {artistProfile && artistProfile.spotify && (
                        <a
                          href={artistProfile && artistProfile.spotify}
                          target="_blank"
                          rel="noreferrer"
                        >
                          <svg
                            version="1.0"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 512.000000 512.000000"
                            preserveAspectRatio="xMidYMid meet"
                          >
                            <g
                              transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
                              stroke="none"
                            >
                              <path
                                d="M2315 5109 c-473 -48 -916 -222 -1305 -512 -123 -93 -395 -365 -489
                                -490 -272 -365 -437 -767 -503 -1232 -17 -118 -17 -512 0 -630 66 -465 231
                                -867 503 -1232 94 -126 366 -398 492 -492 364 -271 769 -437 1232 -503 118
                                -17 512 -16 635 0 492 68 949 268 1319 577 47 39 140 128 206 196 200 207 323
                                384 455 654 122 247 200 505 242 800 17 118 17 512 0 630 -66 463 -234 873
                                -504 1232 -89 118 -282 320 -399 418 -364 304 -805 500 -1284 571 -122 18
                                -477 26 -600 13z m470 -1358 c479 -59 880 -162 1233 -317 280 -124 376 -193
                                406 -295 20 -66 20 -82 0 -148 -30 -103 -120 -170 -226 -171 -51 0 -71 7 -201
                                75 -165 86 -319 149 -480 199 -717 222 -1600 255 -2288 85 -191 -47 -236 -49
                                -307 -13 -108 54 -155 173 -118 297 37 124 115 165 442 231 339 69 545 86 999
                                81 296 -3 404 -8 540 -24z m-167 -875 c419 -57 757 -152 1092 -308 140 -65
                                260 -135 303 -176 36 -35 67 -107 67 -156 0 -74 -55 -155 -125 -187 -72 -33
                                -100 -26 -271 62 -192 100 -322 155 -502 212 -590 190 -1260 215 -1840 67
                                -175 -45 -200 -47 -258 -21 -151 69 -160 297 -14 371 95 49 451 121 735 149
                                137 14 679 5 813 -13z m-264 -816 c471 -27 893 -144 1238 -341 98 -56 142
                                -101 158 -160 28 -102 -43 -201 -144 -203 -33 -1 -79 18 -226 91 -422 211
                                -726 282 -1200 283 -273 0 -548 -29 -790 -83 -52 -11 -125 -21 -162 -21 -63
                                -1 -69 1 -102 33 -80 78 -73 198 16 264 64 48 567 126 898 140 36 2 83 4 105
                                5 22 1 116 -3 209 -8z"
                              />
                            </g>
                          </svg>
                        </a>
                      )}
                      {artistProfile && artistProfile.aurovine && (
                        <a
                          href={artistProfile && artistProfile.aurovine}
                          target="_self"
                          rel="noreferrer"
                        >
                          <svg
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 58 58"
                          >
                            <rect
                              width="58"
                              height="58"
                              rx="29"
                              fill="#37B0C8"
                            />
                            <path
                              d="M3 35h9.5l2.5-4.5h9.5v3h8v-10H20l4.5-7V21h8V10.5C32.5 7 29 4 26.5 4c-2 0-3.5 1-4 1.5L3 35Z"
                              fill="#000"
                            />
                            <path
                              d="M32.5 35.5h-8V49c.1667.6667 1.1 2.4 3.5 4s5.3333.3333 6.5-.5l19.5-29h-9.5l-12 18v-6Z"
                              fill="#000"
                            />
                          </svg>
                        </a>
                      )}
                    </div>
                    <div className="author__wrap">
                      <div
                        className="author__followers_seller_page"
                        tyle={{ marginTop: 10 }}
                      >
                        <p
                          className="link"
                          onClick={() => {
                            setfollowersDialogState(true);
                          }}
                        >
                          <span className="link">
                            {followersCount ? followersCount : 0}
                          </span>
                          followers
                        </p>
                      </div>
                      <div
                        style={{
                          marginTop: 10,
                          // marginRight: 15,
                          width: '50%',
                          display: 'flex',
                          justifyContent: 'flex-end',
                        }}
                      >
                        <FollowButton
                          artistId={artistId}
                          photoUrl={
                            artistProfile && artistProfile.photoUrl
                              ? artistProfile.photoUrl +
                                '_250x250?alt=media&t=' +
                                newCache
                              : '/img/unknow.jpg'
                          }
                          name={
                            artistProfile && artistProfile.name
                              ? artistProfile.name
                              : '-'
                          }
                          onSuccessUnFollowCallback={() => {
                            //decreasing followers count
                            setfollowersCount(followersCount - 1);
                          }}
                          onSuccessFollowCallback={() => {
                            //incresing followers count
                            setfollowersCount(followersCount + 1);
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="w-full discover-screen-artist2 xl:w-9/12 lg:w-8/12 md:w-6/12">
                {artistProfile &&
                  userDataRedux &&
                  userDataRedux.uid &&
                  artistProfile.adminState &&
                  artistProfile.adminState === 'REJECT' &&
                  artistProfile.creatorId &&
                  artistProfile.creatorId === userDataRedux.uid && (
                    <div className="px-2 pt-5 pb-2">
                      <Alert severity={'error'}>
                        <AlertTitle>
                          <>This MusicArtist profile is rejected by Admin</>
                        </AlertTitle>

                        <>
                          Rejection reason: <br />
                          {artistProfile && artistProfile.rejectionReason
                            ? artistProfile.rejectionReason
                            : 'none'}{' '}
                        </>
                      </Alert>
                    </div>
                  )}

                <div className="p-gutter">
                  <div className="profile">
                    <div className="ArtistTab">
                      <AntTabs
                        value={value}
                        onChange={handleChange}
                        aria-label="ant example"
                        variant="scrollable"
                        scrollButtons="auto"
                      >
                        <AntTab label="On Sale" />
                        {(isMyProfile || isAdmin) && (
                          <AntTab label="Settings" />
                        )}
                      </AntTabs>
                    </div>
                  </div>
                </div>
                <div
                  className="bg-white flex-auto"
                  style={{ marginBottom: 50 }}
                >
                  <TabPanel value={value} index={0}>
                    <OnSellsTab artistId={artistId} />
                  </TabPanel>

                  {(isMyProfile || isAdmin) && (
                    <TabPanel value={value} index={1}>
                      <SettingsTab
                        forceUpdate={forceUpdate}
                        newCache={newCache}
                        artistId={artistId}
                        artistProfile={artistProfile}
                        setartistProfile={setartistProfile}
                      />
                    </TabPanel>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>

      <FollowersDialog
        dialogState={followersDialogState}
        setdialogState={setfollowersDialogState}
        artistId={artistId}
      />

      <ImageViewerDialog
        dialogState={imageViewerDialogState}
        setdialogState={setimageViewerDialogState}
        imageUrl={
          artistProfile && artistProfile.photoUrl
            ? `${artistProfile.photoUrl + '_250x250?alt=media&t=' + newCache}`
            : '/img/unknow.jpg'
        }
      />
    </>
  );
}

function TabPanel(props) {
  const { children, value, index, ...other } = props;
  const userDataRedux = useSelector((state) => state.authReducer.userData);

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && children}
    </div>
  );
}

const AntTabs = withStyles({
  root: {
    borderBottom: '1px solid #e8e8e8',
  },
  indicator: {
    backgroundColor: '#1890ff',
  },
})(Tabs);

const AntTab = withStyles((theme) => ({
  root: {
    textTransform: 'none',
    minWidth: 72,
    fontWeight: theme.typography.fontWeightRegular,
    marginRight: theme.spacing(4),
    fontFamily: [
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(','),
    '&:hover': {
      color: '#40a9ff',
      opacity: 1,
    },
    '&$selected': {
      color: '#1890ff',
      fontWeight: theme.typography.fontWeightMedium,
    },
    '&:focus': {
      color: '#40a9ff',
      outline: 'none',
    },
  },
  selected: {},
}))((props) => (
  <Tab
    disableRipple
    {...props}
    style={{
      minWidth: 72,
      textTransform: 'inherit',
      color: '#1890ff',
    }}
  />
));

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  padding: {
    padding: theme.spacing(3),
  },
}));
